import Dialog from "@mui/material/Dialog";
import React, { useContext, useState } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Box,
  Grid,
  Stack,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import { useMutation } from "@apollo/client";
import { BiMinusCircle } from "react-icons/bi";
import { DELETE_CUSTOMER } from "../../Schema/Customer";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

export default function DeleteCustomer({
  open,
  editData,
  setRefetch,
  handleClose,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  const [deleteCustomerOfGeneralInvoice] = useMutation(DELETE_CUSTOMER, {
    onCompleted: ({ deleteCustomerOfGeneralInvoice }) => {


      console.log("deleteCustomerOfGeneralInvoice ==>", deleteCustomerOfGeneralInvoice);

      setLoading(false);
      if (deleteCustomerOfGeneralInvoice?.status === true) {
        setAlert(true, "success", deleteCustomerOfGeneralInvoice?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteCustomerOfGeneralInvoice?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteCustomerOfGeneralInvoice({
      variables: {
        deleteCustomerOfGeneralInvoiceId: editData?._id,
      },
    });
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">Delete Customer</Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>
              Do you want to delete this data?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {loading ? (
              <Button className="btn-delete" fullWidth>
                {t("loading")}
              </Button>
            ) : (
              <Button className="btn-delete" fullWidth onClick={handleDelete}>
                {t("delete")}
              </Button>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
